import React, { useEffect, useState } from "react";
import "./Form.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ErrorMessage, Field, Form, Formik } from "formik";
import axios from "axios";
import * as Yup from "yup";
import parsePhoneNumberFromString from "libphonenumber-js";
import ErrorIcon from "../../Images/Errortoast.png";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import SuccessIcon from "../../Images/Successtoast.png";

import "react-toastify/dist/ReactToastify.css";
import useLocation from "../../utils/Location";

export default function Formsection() {
  const apiUrl = process.env.REACT_APP_BACKEND_API;
  // const navigate = useNavigate();
  const {countryCode} = useLocation();

  // const [countryCodeData, setCountryCodeData] = useState("in");
  // const [responseMessage, setResponseMessage] = useState("");
  const [responseMessage, setResponseMessage] = useState({
    success: null,
    message: "",
  });

  // const [countryList, setCountryList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isValidPhoneNumber = (inputNumber, country) => {
    try {
      const phoneNumber = parsePhoneNumberFromString(
        inputNumber,
        country?.toUpperCase()
      );
      return phoneNumber?.isValid() || false;
    } catch (err) {
      console.log(err);
    }
  };

  // const getCountryFromLocation = () => {
  //   return new Promise((resolve, reject) => {
  //     navigator.geolocation.getCurrentPosition(
  //       async (position) => {
  //         try {
  //           const { latitude, longitude } = position.coords;
  //           const response = await fetch(
  //             `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
  //           );
  //           const data = await response.json();
  //           resolve(data?.countryCodeData || null);
  //         } catch (error) {
  //           console.error("Error fetching location data:", error);
  //           reject(error);
  //         }
  //       },
  //       (error) => {
  //         console.error("Geolocation error:", error);
  //         reject(error);
  //       }
  //     );
  //   });
  // };

  // const fetchDynamicCountry = async () => {
  //   try {
  //     const countryList = await axios.get(`${apiUrl}/api/v1/user/getCountries`);
  //     setCountryList(countryList?.data?.result);
  //     const countryCodeData = await getCountryFromLocation();
  //     if (countryCodeData) setCountryCodeData(countryCodeData?.toLowerCase());
  //   } catch (error) {
  //     console.error("Error fetching country data:", error);
  //   }
  // };

  // const fetchLocation = async () => {
  //   try {
  //     const res = await fetch(
  //       `${apiUrl}/api/v1/business/getCountryCodePhoneCode`
  //     );
  //     const { result } = await res.json();
  //     setCountryCodeData(
  //       result?.countryCode?.toLowerCase() || countryCode || "in"
  //     );
  //   } catch (err) {
  //     console.log("Could not fetch country. Defaulting to IN");
  //   }
  // };

  // useEffect(() => {
  //   fetchLocation();
  //   fetchDynamicCountry();
  // }, []);

  const closeModal = () => setIsModalOpen(false);
  const validationSchema = Yup.object({
    name: Yup.string()
      .trim()
      .matches(/^[A-Za-z\s]+$/, "Name can only contain letters")
      .required("Name is required"),
    email: Yup.string()
      .trim()
      .email("Invalid email")
      .required("Email is required"),

    city: Yup.string()
      .trim()
      .matches(
        /^[A-Za-z\s.-]+$/,
        "City can only contain letters, spaces, dots, and hyphens"
      )
      .required("City is required"),
    contact: Yup.string()
      .required("Phone number is required")
      .test("valid-phone", "Enter a valid phone number", (v) =>
        isValidPhoneNumber(v || "")
      ),
    message: Yup.string()
      .trim()
      .min(10, "Message must be at least 10 characters")
      .max(500, "Message can be maximum 500 characters"),
  });

  const initialValues = {
    enquiry_from: "RealEstate",
    name: "",
    email: "",
    // country: "",
    city: "",
    contact: "",
    message: "",
    requestFromLanding: true,
  };

  const handleSubmit = async (values, resetForm) => {
    try {
      const payload = { ...values };
      const response = await axios.post(
        `${apiUrl}/api/v1/business/createBusinessEnquiry`,
        payload
      );
      setResponseMessage({
        success: true,
        message: response?.data?.message || "Enquiry submitted successfully!",
      });
      setIsModalOpen(true);

      // Auto close
      setTimeout(() => setIsModalOpen(false), 5000);

      resetForm();
      // setTimeout(() => navigate("/realestate/thankyou"), 300);
    } catch (error) {
      setResponseMessage({
        success: false,
        message: error?.response?.data?.message || "Some Error Occurred!",
      });
      setIsModalOpen(true);
      setTimeout(() => setIsModalOpen(false), 5000);

      // toast.error(error?.response?.data?.message || "Some Error Occurred!", {
      //   position: "top-right",
      //   autoClose: 30000,
      // });
    }
  };

  return (
    <div className="form" id="enquiry-form">
      <h2>Enquiry Form</h2>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => handleSubmit(values, resetForm)}
      >
        {({ values, errors, touched, setFieldValue, setFieldTouched, isSubmitting }) => (
          <Form>
            <div className="input">
              <Field name="name" placeholder="Name" />
              <ErrorMessage className="error" name="name" component="div" />
            </div>

            <div className="input">
              <Field name="email" type="email" placeholder="Email" />
              <ErrorMessage className="error" name="email" component="div" />
            </div>

            <div className="input">
              <Field name="city" type="text" placeholder="City" />
              <ErrorMessage className="error" name="city" component="div" />
            </div>

            {/* <div className="input">
              <Field as="select" name="country">
                <option value="">Select Country</option>
                {countryList?.map(
                  (country) =>
                    country?.id && (
                      <option key={country.name} value={country.short_code}>
                        {country.name.charAt(0).toUpperCase() +
                          country.name.slice(1)}
                      </option>
                    )
                )}
              </Field>
              <ErrorMessage className="error" name="country" component="div" />
            </div> */}

            <div className="input">
              <PhoneInput
                country={countryCode || "in"}
                enableSearch
                value={values.contact}
                countryCodeEditable={false}
                onChange={(value) => setFieldValue("contact", `+${value}`)}
                onBlur={() => setFieldTouched("contact", true)}
                inputClass="phone-input"
              />
              {errors.contact && touched.contact && (
                <div className="error">{errors.contact}</div>
              )}
            </div>

            <div className="input">
              <Field
                as="textarea"
                name="message"
                rows="2"
                placeholder="Enter your enquiry details (optional)"
              />
              <ErrorMessage className="error" name="message" component="div" />
            </div>

            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </Form>
        )}
      </Formik>

      {isModalOpen && (
        <div className="modal1 realestateseoadsmodal">
          <div className="modal-content1">
            <span
              className="close closeIconstyle"
              onClick={() => setIsModalOpen(false)}
            >
              X
            </span>

            <div>
              {responseMessage.success ? (
                <img
                  className="toastsuccessimg"
                  src={SuccessIcon}
                  alt="success"
                />
              ) : (
                <img className="toastsuccessimg" src={ErrorIcon} alt="error" />
              )}
            </div>

            <div className="headtostmsg">
              {responseMessage.success ? "Enquiry Received!" : "Error!"}
            </div>

            <p className="responseMessagestyle">{responseMessage.message}</p>
          </div>
        </div>
      )}
    </div>
  );
}
